import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Input,
} from "reactstrap";
import { reduxForm } from 'redux-form'
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import Messages from '../../../notifications/Messages'
import Errors from '../../../notifications/Errors'
import { validatePassword, validateEmail } from '../../../lib/validation'
import AdminUserTypes from './constants'
import CheckboxTreeList from "../../controls/_CheckboxTreeList";
import Checkboxlist from "../../controls/_Checkboxlist";
import * as common from "../../../lib/common"

class EditUser extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this)
    this.state = {
      password: ''
    }
  }

  submit = () => {
    if (this.formValid()) {
      var user = {
        user: this.props.item.user || {},
        permissions: this.props.item.permissions || []
      }
      this.props.updateUser(user);
    }
  }

  formValid = () => {
    let ok = true
    const values = this.props.data
    this.props.resetError()
    if (!values.email) {
      this.setData("email", "");
    }
    if (!values.TenDayDu || values.TenDayDu.trim() == "") {
      this.props.adminUserSetErrors('Chưa nhập họ và tên')
      ok = false
    }
    if (values.email) {
      if (!validateEmail(values.email)) {
        this.props.adminUserSetErrors('Email không hợp lệ')
        ok = false
      }
    }
    if (values.password) {
      let msg = validatePassword(values.password);
      if (msg) {
        this.props.adminUserSetErrors(msg)
        ok = false
      }
    }

    return ok
  }

  handleDateChange = (e) => {
    this.props.change('NgaySinh', e);
    this.setData("NgaySinh", e);
  }

  onHandleRemoveQuanLy = () => {
    this.props.change('QuanLyId', null)
    this.setData("QuanLyId", null);
  }
  onHandleChoiceQuanLy = (nodesChecked) => {
    let userId = 0
    if (nodesChecked && nodesChecked.length > 0) {
      userId = nodesChecked[0].value
    }
    this.props.change('QuanLyId', userId)
    this.setData("QuanLyId", userId);
  }
  onHandleRemoveLuong = () => {
    this.props.change('BacLuongId', null)
    this.setData("BacLuongId", null);
  }
  handleLuongChange = (nodesChecked) => {
    let bacluong = 0
    if (nodesChecked && nodesChecked.length > 0) {
      bacluong = nodesChecked[0].value
    }
    this.props.change('BacLuongId', bacluong)
    this.setData("BacLuongId", bacluong);
  };
  handleRoleChange = (values) => {
    this.props.change("permissions", values.join(","));
    this.props.handleRoleChange(values);
  }
  handleInputChange = (e) => {
    const name = e.target.name;
    let value = undefined;
    switch (name) {
      case "password":
        value = common.removeUnicode(e.target.value)
        this.setState({password: value})
        break;
      case "email":
        value = e.target.value;
        break;
      case "active_account":
        value = e.target.checked;
        break;
      case "TenDayDu":
        value = e.target.value;
        break;
      case "DienThoai":
        value = e.target.value;
        break;
      case "DiaChi":
        value = e.target.value;
        break;
    }

    this.setData(name, value);
  }

  setData = (name, value) => {
    let data = {};

    data[name] = value;
    this.props.adminUserSetDataForUser(data);
    this.props.adminUserSetErrors("");
  }

  getDateFormated = (date) => {
    if (date) {
      return moment(date).format("DD/MM/YYYY")
    }
  }

  onClose = (e) => {
    this.props.onClose(this.props.data);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.parentProps.adminUserList.type == AdminUserTypes.ITEM_UPDATE_SUCCESS) {
      setTimeout(() => {
        this.props.fetchList();
        this.onClose();
      }, 2000)
    }
  }

  formatOptionLabel = (option) => {
    const address = option.address ? `(${option.address})` : ''
    return (
      <div>
        {option.label}<span className={"item_unit"}>{'\u00A0'}{address}</span>
      </div>
    )
  }

  userFormatOptionLabel = (option) => {
    const address = option.address ? `(${option.address})` : ''
    return (
      <div>
        {option.label}<span className={"item_unit"}>{'\u00A0'}{address}</span>
      </div>
    )
  }

  convertToMoment = (date) => {
    if (date === undefined) {
      return moment();
    }

    if (typeof date == 'string') {
      return moment(date);
    }
    return date;
  }

  render() {
    const {
      data,
      requesting,
      messages,
      errors,
      selectedOption
    } = this.props
    return (
      <div className="animated fadeIn">
        <Modal isOpen={this.props.isEditing} className="modal-lg" contentClassName="modal-content-fit-height" modalClassName={"modal-fit admin-user"}>
          <ModalHeader>Cập nhật thông tin cho <b>{data.username}</b></ModalHeader>
          <ModalBody>
            <div className="col-sm-12 pl-0 pr-0 mb-2">
              <div className="col-sm-12">Chú ý tắt unikey, vietkey khi gõ Mật khẩu</div>
            </div>
            <BlockUi tag="div" blocking={requesting}>
              <div className="col-sm-12 pl-0 pr-0">
                <div className="col-sm-6 mb-2 pull-left input-group display-table">
                  <div className="input-group-prepend display-table-cell">
                    <span className="input-group-text" id="username">Tài khoản</span>
                  </div>
                  <input type="text" name="username" className="form-control display-table-cell" readOnly={true} value={data.username || ''}
                    aria-describedby="username" autoComplete="off" />
                </div>
                <div className="col-sm-6 mb-2 pull-left input-group display-table">
                  <div className="input-group-prepend display-table-cell">
                    <span className="input-group-text" id="TenDayDu">Họ tên (*)</span>
                  </div>
                  <input type="text" name="TenDayDu" className="form-control display-table-cell" onChange={this.handleInputChange} value={data.TenDayDu || ''}
                    aria-describedby="TenDayDu" autoComplete="off" />
                </div>


                <div className="col-sm-6 mb-2 pull-left input-group display-table">
                  <div className="input-group-prepend display-table-cell">
                    <span className="input-group-text" id="password">Mật khẩu</span>
                  </div>
                  <input type="text" name="password" value={this.state.password || ''} onChange={this.handleInputChange} className="form-control display-table-cell"
                    aria-describedby="password" autoComplete="off" />
                </div>
                <div className="col-sm-6 mb-2 pull-left input-group display-table">
                  <div className="input-group-prepend display-table-cell">
                    <span className="input-group-text" id="email">Email</span>
                  </div>
                  <input type="text" name="email" className="form-control display-table-cell" onChange={this.handleInputChange} value={data.email || ''}
                    aria-describedby="email" autoComplete="off" />
                </div>
                <div className="col-sm-6 mb-2 pull-left input-group display-table">
                  <div className="input-group-prepend display-table-cell">
                    <span className="input-group-text" id="DienThoai">Điện thoại</span>
                  </div>
                  <input type="text" name="DienThoai" className="form-control display-table-cell" onChange={this.handleInputChange} value={data.DienThoai || ''}
                    aria-describedby="DienThoai" />
                </div>

                <div className="col-sm-6 mb-2 pull-left input-group display-table">
                  <div className="input-group-prepend display-table-cell">
                    <span className="input-group-text" id="NgaySinh">Ngày sinh</span>
                  </div>
                  <DatePicker name="NgaySinh" dateFormat="DD/MM/YYYY"
                    selected={this.convertToMoment(data.NgaySinh)}
                    onChange={e => this.handleDateChange(e)} className={"form-control"}
                    aria-describedby="NgaySinh" autoComplete="off" />
                </div>
                <div className="col-sm-6 mb-2 pull-left input-group display-table">
                  <div className="input-group-prepend display-table-cell">
                    <span className="input-group-text">Hoạt động</span>
                  </div>
                  <label className="input-group-text text-danger display-tabble-cell pl-1" htmlFor="active_account">
                    <Input className="form-checkbox-append ml-0"
                      onChange={this.handleInputChange}
                      aria-label="Small"
                      aria-describedby="inputGroup-sizing-sm"
                      type="checkbox" name="active_account"
                      id="active_account"
                      defaultChecked={data.active_account} />
                  </label>
                </div>
                <div className="col-sm-6 mb-2 pull-left input-group display-table">
                  <div className="input-group-prepend display-table-cell">
                    <span className="input-group-text" id="DiaChi">Địa chỉ</span>
                  </div>
                  <input type="text" name="DiaChi" className="form-control display-table-cell"
                    onChange={this.handleInputChange} value={data.DiaChi || ''}
                    aria-describedby="DiaChi" placeholder="Địa chỉ" autoComplete="off" />
                </div>
                <div className="col-sm-6 mb-2 pull-left input-group display-table">
                  <div className="form-group col-sm-12 pr-0 pl-0">
                    <CheckboxTreeList
                      placeholder={`--Chọn quản lý--`}
                      nodes={this.props.listUsers}
                      checked={this.props.userSelection}
                      isMultiChoice={false}
                      onHandleRemove={(item) => this.onHandleRemoveLuong(item)}
                      onChoice={e => this.onHandleChoiceQuanLy(e)}
                    />
                  </div>
                </div>
                <div className="col-sm-6 mb-2 pull-left input-group display-table">
                  <div className="form-group col-sm-12 pr-0 pl-0">
                  <CheckboxTreeList
                      placeholder={`--Lương cơ bản--`}
                      nodes={this.props.listLuong}
                      checked={this.props.userLuongSelection}
                      isMultiChoice={false}
                      onHandleRemove={(item) => this.onHandleRemoveLuong(item)}
                      onChoice={e => this.handleLuongChange(e)}
                    />
                  </div>
                </div>
                <div className="col-sm-12 col-xs-12 mb-2 pull-left">
                  <div className="form-group col-sm-12 pr-0 pl-0">
                    <div className="form-group">
                      <label>Thuộc nhóm người dùng</label>
                      <Checkboxlist
                        onChange={(values) => this.handleRoleChange(values)}
                        options={this.props.permissionList}
                        values={this.props.permissions}
                        isOnceChoice={false}
                        enableSearchBox={true}
                        name={"permissions"}
                        className="p-1"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row col-sm-12">
                <div className="col-sm-12 mb-2 pull-left">
                  {!requesting && errors && !!errors.length && (
                    <Errors errors={errors} />
                  )}
                  {!requesting && messages && !!messages.length && (
                    <Messages messages={messages} />
                  )}
                </div>
              </div>
              <div className="row col-sm-12">
                <div className="col-sm-12 mb-2 pull-left">
                  <div className="btn-group float-right" role="group">
                    <Button className="mr-1" color="primary" onClick={e => this.submit()}><i className="fa fa-floppy-o"></i>&nbsp;Cập nhật</Button>
                    <Button color="secondary" onClick={e => this.onClose()}><i className="fa fa-close"></i>&nbsp;Đóng</Button>
                  </div>
                </div>
              </div>
            </BlockUi>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

const formed = reduxForm({
  form: 'form-editUser',
})(EditUser)

export default formed;


// WEBPACK FOOTER //
// ./src/views/Admin/AdminUser/_EditUser.js